import { Fragment } from 'react';
import { Collapse, List, ListItem, ListItemText } from '@material-ui/core';

import { ProductNameList } from './components';
import { CardCustomization, ExpandIcon } from '../shared';

import { useCustomizationsGroups } from './hooks';

import makeClasses from './CustomizationsGroups.style';

import type {
  FullMenuCatalog,
  IMenuCustomization,
} from 'features/menu-page/domain';
import type { ProductId } from 'shared/domain';

export function CustomizationsGroups(props: Props) {
  const { catalog, filterByProductId = NaN, toggleOnOff } = props;

  const {
    lang,
    collapse,
    hasProductId,
    customGroupsToRender,
    handleClickCollapse,
  } = useCustomizationsGroups({ catalog, productId: filterByProductId });

  const _classes = makeClasses();

  return (
    <List
      component='section'
      aria-label='customization-groups'
      classes={{ root: _classes.groups }}
    >
      {customGroupsToRender.map(customGroup => (
        <Fragment
          key={`custom-group-${customGroup.id}-pID-${customGroup.productId}`}
        >
          <ListItem
            button
            component='button'
            onClick={handleClickCollapse}
            data-custom-group-id={customGroup.id}
            classes={{ root: _classes.groupItem }}
          >
            <ExpandIcon
              isExpanded={collapse === customGroup.id}
              className={customGroupsToRender.length === 1 ? 'displayNone' : ''}
            />
            <ListItemText
              primary={customGroup.description}
              secondary={
                !hasProductId && (
                  <>
                    {`${lang.customGroup.secondary.label} `}
                    <ProductNameList
                      customGroupId={customGroup.id}
                      catalog={catalog}
                    />
                  </>
                )
              }
              classes={{
                primary: _classes.groupItemTextPrimary,
                secondary: _classes.groupItemTextSecondary,
              }}
            />
          </ListItem>
          <Collapse
            mountOnEnter
            unmountOnExit
            aria-label='customization-list-collapse'
            in={collapse === customGroup.id}
          >
            <List disablePadding aria-label='customization-list'>
              {customGroup.items.map((customItem, cItemIndex) => (
                <CardCustomization
                  key={`custom-item-${customItem.id}`}
                  renderIndex={cItemIndex}
                  customization={customItem}
                  toggleOnOff={toggleOnOff}
                />
              ))}
            </List>
          </Collapse>
        </Fragment>
      ))}
    </List>
  );
}

interface Props {
  catalog: FullMenuCatalog;
  filterByProductId?: ProductId;
  toggleOnOff: (c: boolean, item: IMenuCustomization) => void;
}
